__turbopack_context__.v({
  "ctaCountdownWrapper": "hero-module__HNXeQG__ctaCountdownWrapper",
  "hero": "hero-module__HNXeQG__hero",
  "heroContent": "hero-module__HNXeQG__heroContent",
  "heroCountdown": "hero-module__HNXeQG__heroCountdown",
  "heroImage": "hero-module__HNXeQG__heroImage",
  "heroImageGradient": "hero-module__HNXeQG__heroImageGradient",
  "heroSubtitle": "hero-module__HNXeQG__heroSubtitle",
  "heroTitle": "hero-module__HNXeQG__heroTitle",
  "heroTrustpilot": "hero-module__HNXeQG__heroTrustpilot",
  "subCTA": "hero-module__HNXeQG__subCTA",
  "trustpilotScore": "hero-module__HNXeQG__trustpilotScore",
  "trustpilotWrapper": "hero-module__HNXeQG__trustpilotWrapper",
  "wave": "hero-module__HNXeQG__wave",
  "waveWrapper": "hero-module__HNXeQG__waveWrapper",
});
